import React from 'react';
import { Game } from './components/Game';
export function App() {
  return <Game data-id="element-0" />;
}